/**
 * Light-dismiss for the VAT info popover rendered by `snippets/up2-vat-note.liquid`.
 *
 * The popover is a native <details>, which opens and closes on its own summary but ignores clicks
 * elsewhere. These document-level listeners close any open popover on an outside click or tap and on
 * Escape. Delegated on the document so price blocks re-rendered on variant change keep working.
 */
(function () {
  'use strict';

  if (window.up2VatNoteReady) return;
  window.up2VatNoteReady = true;

  var SELECTOR = '.up2-vat-note__info[open]';

  document.addEventListener('click', function (event) {
    document.querySelectorAll(SELECTOR).forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(SELECTOR).forEach(function (details) {
      details.removeAttribute('open');
      if (details.contains(document.activeElement)) details.querySelector('summary').focus();
    });
  });
})();
